import { TableCell } from "@mui/material";
import { AppDatePicker } from "../../../../../../shared/components/AppDatePicker";
import { transformDate } from "../../../helpers";
import styles from "./styles.module.css";

interface Props {
  validDate: string;
  onChange: (date: Date) => void;
}

export const StaticTokenValidationCell = (props: Props) => {
  return (
    <TableCell className={styles["date-cell"]}>
      <AppDatePicker
        value={transformDate(props.validDate)}
        onChange={(date) => props.onChange(date as Date)}
        disablePast
      />
    </TableCell>
  );
};
